<!--@format-->
<template>
    <div class="global-category-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>{{ widgetTitle }}</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <div class="form-wrapper">
                    <div class="input-container">
                        <app-input
                            v-model="categoryName"
                            label="Category Name"
                            placeholder="Name"
                            :is-valid="!submitted || $v.categoryName.required"
                            error="Name is required"
                        />
                    </div>
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-btn transparent-btn" @click="closeWidget">
                        Cancel
                    </app-button>
                </div>
                <div class="action-container">
                    <app-button @click="save()">Save</app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const AppInput = () => import('@/components/common/app-input.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');

import EventBus from '@/scripts/event-bus.js';
import { required } from 'vuelidate/lib/validators';
import { GlobalCategoryService } from '@/scripts/services/global-category/global-category-service';

export default {
    name: 'global-category-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'app-input': AppInput,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            submitted: false,
            categoryName: null,
        };
    },

    validations: {
        categoryName: {
            required,
        },
    },

    computed: {
        accountId() {
            return this.widget.accountId;
        },

        widgetTitle() {
            return this.loading ? 'Saving...' : 'Add Category';
        },
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        save() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                this.createCategory();
            }
        },

        createCategory() {
            this.loading = true;

            const categoryPayload = {
                categoryName: this.categoryName,
            };

            GlobalCategoryService.post(this.accountId, categoryPayload)
                .then(() => {
                    this.$helpers.showSuccessNotification(
                        'Your category has been successfully created'
                    );
                    EventBus.$emit('global-categories:update');
                    this.closeWidget();
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error occurred while creating your category',
                        { error },
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style>
.global-category-widget .form-wrapper {
    display: flex;
    flex-direction: column;
}

.global-category-widget .widget-contents-container .transparent-btn {
    background: transparent;
    color: #877d88;
    border: none;
}

.global-category-widget .widget-contents-container .transparent-btn:hover {
    background: #e1e0e5;
}

.global-category-widget .app-input {
    margin-bottom: 16px;
}
</style>
